import React, { useState } from "react";
import { AttentionSelectiveExercise } from "../../modules/pratiquer/Cognitif/AttentionSelectiveExercise";
import { ExerciseCard } from "../../components/ExerciseCard";
import { mockPratiquerExercises } from "../../modules/exercises.mock";
import { playGamesMock } from "../../modules/play/mock";
import { MiniGameContainer, PlayGameCard } from "../../modules/play/components";
import { PlayGameMeta } from "../../modules/play/core";

// Play · Mini-jeux : affiche les jeux mock + un mini-jeu démo.
export default function PlayMiniJeux() {
  const [activeGame, setActiveGame] = useState<PlayGameMeta | null>(null);

  const handlePlay = (game: PlayGameMeta) => {
    if (game.id === "play-attention-1") {
      setActiveGame(game);
      return;
    }
    alert("Mini-jeu bientôt disponible.");
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Play · Mini-jeux</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Petits jeux pour entraîner l'attention et la rapidité. Démo : attention sélective + idées
          d'entraînements courts.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Catalogue</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {playGamesMock.map((game) => (
            <PlayGameCard key={game.id} game={game} onPlay={() => handlePlay(game)} />
          ))}
        </div>
      </section>

      {activeGame && (
        <MiniGameContainer game={activeGame} onBack={() => setActiveGame(null)}>
          {activeGame.id === "play-attention-1" ? (
            <AttentionSelectiveExercise />
          ) : (
            <p className="text-sm text-slate-600 dark:text-slate-300">
              Contenu du mini-jeu à venir.
            </p>
          )}
        </MiniGameContainer>
      )}

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Entraînements rapides</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {mockPratiquerExercises.map((ex) => (
            <ExerciseCard key={ex.id} exercise={ex} />
          ))}
        </div>
      </section>
    </div>
  );
}
